<template>
	<section class="quote_source">

		<div class="container">

			<div class="quote_source__inner">
				<blockquote>
					<div
						v-html='quote'
						class='quote'
					></div>
					<div
						class='quote_source'
						v-if="quote_source"
						v-html='quote_source'
					></div>
				</blockquote>

			</div>

		</div>
	</section>
</template>

<script>
export default {
	data() {
		return {};
	},

	props: {
		quote: {},
		quote_source: {},
	},

	computed: {},

	watch: {},

	methods: {},

	components: {},

	created() {},
	mounted() {
		let quote_sourceIcons = document.querySelectorAll('.quote_source_icon');

		quote_sourceIcons.forEach((element) => {
			window.onscroll = function () {
				var theta = (document.documentElement.scrollTop / 100) % Math.PI;

				element.style.transform = 'rotate(' + theta + 'rad)';
			};
		});
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.quote_source {
	/* padding-left: 48px; */

	&__inner {
		margin-left: 0;
		padding-left: 24px;
		border-left: 1px solid var(--light-grey);

		blockquote {
			margin-top: 0;
			margin-bottom: 0;
			margin-left: 0;
			margin-right: 0;
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/QuoteSource.vue